
import RegisterMoreDetails from '../../components/registration/RegisterMoreDetails'
import RegisterNavbar from '../../components/registration/RegisterNavbar'

export default function RegisterMoreDetailsPage() {
    return (
        <>
            <RegisterNavbar />
            <RegisterMoreDetails />
        </>
    )
}
